import { resolveComponent as _resolveComponent, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "m-auto px-8 md:px-20" }
const _hoisted_2 = { class: "max-w-screen-2xl m-auto" }
const _hoisted_3 = { class: "py-10 flex justify-between" }
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = { class: "flex overflow-x-auto md:grid md:grid-cols-3 lg:grid-cols-7 gap-3 py-4" }
const _hoisted_6 = { class: "mb-4 flex flex-shrink font-bold" }
const _hoisted_7 = { class: "rotate-x-180 overflow-x-scroll" }
const _hoisted_8 = { class: "flex justify-between items-center" }
const _hoisted_9 = { class: "flex justify-between items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!
  const _component_NextButton = _resolveComponent("NextButton")!
  const _component_stato_card = _resolveComponent("stato-card")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_NextTable = _resolveComponent("NextTable")!
  const _component_InfiniteLoading = _resolveComponent("InfiniteLoading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
      _createVNode(_component_Loading, { visible: _ctx.loading }, null, 8, ["visible"])
    ])),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Breadcrumbs, { paths: _ctx.paths }, null, 8, ["paths"]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_NextButton, {
              variant: "outline-secondary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back())),
              class: "w-44 hidden text-sm sm:block py-2 px-4"
            }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createTextVNode(" < Indietro ")
              ])),
              _: 1
            }),
            _createVNode(_component_NextButton, {
              variant: "primary",
              component: "router-link",
              to: {name: 'FormContatto'},
              class: "w-44 ml-3 text-sm py-2 px-4 m-0 hidden sm:block"
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createTextVNode(" + Aggiungi ")
              ])),
              _: 1
            })
          ])
        ]),
        _cache[8] || (_cache[8] = _createElementVNode("h3", { class: "text-3xl font-bold" }, "Contatti", -1)),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.businessUnits, (bu) => {
            return (_openBlock(), _createBlock(_component_stato_card, {
              key: bu.id,
              "sigla-progetto": bu.label,
              "sigla-stato": _ctx.getLabel(_ctx.azienda.stati[bu.id]),
              progetto: bu.nome,
              stato: _ctx.ENomiStato[_ctx.azienda.stati[bu.id]] || _ctx.ENomiStato[0],
              "colore-stato-class": `bg-next-${_ctx.getColoriStati(_ctx.azienda.stati[bu.id])}`
            }, null, 8, ["sigla-progetto", "sigla-stato", "progetto", "stato", "colore-stato-class"]))
          }), 128))
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gruppi_contatti, (gc) => {
          return (_openBlock(), _createElementBlock("div", {
            key: gc.id
          }, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(gc.nome), 1),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_NextTable, {
                class: "rotate-x-180 w-full border-separate border-spacing-3 py-4",
                cols: _ctx.contattiCols,
                "onUpdate:cols": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.contattiCols) = $event)),
                rows: _ctx.Contatti(gc.id)
              }, _createSlots({ _: 2 }, [
                _renderList(_ctx.Contatti(gc.id), (c, j) => {
                  return {
                    name: `td_${j}_5`,
                    fn: _withCtx(() => [
                      _createVNode(_component_router_link, {
                        to: {name:'DettaglioContatto', params:{id:c.cliente_id, cid:c.id}},
                        class: "block text-center inset-0 absolute flex items-center justify-center"
                      }, {
                        default: _withCtx(() => _cache[4] || (_cache[4] = [
                          _createElementVNode("i", { class: "icon-chevron_destra" }, null, -1)
                        ])),
                        _: 2
                      }, 1032, ["to"])
                    ])
                  }
                }),
                _renderList(_ctx.Contatti(gc.id), (c, j) => {
                  return {
                    name: `td_${j}_3`,
                    fn: _withCtx(() => [
                      _withDirectives(_createElementVNode("div", _hoisted_8, [
                        _createElementVNode("span", null, _toDisplayString(c.telefono_1), 1),
                        _createVNode(_component_NextButton, {
                          component: "a",
                          href: `tel:${c.telefono_1}`,
                          variant: "primary",
                          class: "w-10 px-3 py-1 flex items-center justify-center ml-3"
                        }, {
                          default: _withCtx(() => _cache[5] || (_cache[5] = [
                            _createElementVNode("i", { class: "icon-telefono" }, null, -1)
                          ])),
                          _: 2
                        }, 1032, ["href"])
                      ], 512), [
                        [_vShow, c.telefono_1]
                      ])
                    ])
                  }
                }),
                _renderList(_ctx.Contatti(gc.id), (c, j) => {
                  return {
                    name: `td_${j}_4`,
                    fn: _withCtx(() => [
                      _withDirectives(_createElementVNode("div", _hoisted_9, [
                        _createElementVNode("span", null, _toDisplayString(c.email), 1),
                        _createVNode(_component_NextButton, {
                          component: "a",
                          href: `mailto:${c.email}`,
                          variant: "primary",
                          class: "w-10 px-3 py-1 flex items-center justify-center"
                        }, {
                          default: _withCtx(() => _cache[6] || (_cache[6] = [
                            _createElementVNode("i", { class: "icon-paper_plane" }, null, -1)
                          ])),
                          _: 2
                        }, 1032, ["href"])
                      ], 512), [
                        [_vShow, c.email]
                      ])
                    ])
                  }
                })
              ]), 1032, ["cols", "rows"])
            ])
          ]))
        }), 128)),
        _createVNode(_component_InfiniteLoading, {
          onInfinite: _ctx.fetchNextContattiPage,
          identifier: _ctx.infiniteIdentifier,
          style: {"min-height":"1px"}
        }, {
          complete: _withCtx(() => _cache[7] || (_cache[7] = [
            _createElementVNode("div", { class: "text-center pb-3" }, "Non ci sono altri contatti.", -1)
          ])),
          _: 1
        }, 8, ["onInfinite", "identifier"])
      ])
    ])
  ], 64))
}